import {z} from 'zod'

export const plusLoadSchema = z.object({
  plusLoadExpected: z.boolean().optional()
})
